<template>
  <div class="copyright width">
    <div class="directory">
      <p>
        <span>本会服务</span>
      </p>
      <el-menu
        class="el-menu-vertical-demo"
        background-color="#ccc"
        :unique-opened="true"
      >

        <el-submenu index="1">
          <template slot="title">
            <span>作品著作权登记</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1" @click.native="detail(1)">作品登记指南</el-menu-item>
            <el-menu-item index="1-2" @click.native="detail(2)">作品收费标准</el-menu-item>
            <el-menu-item index="1-3" @click.native="detail(3)">作品登记须知</el-menu-item>
            <el-menu-item index="1-4" @click.native="detail(4)">作品登记流程</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="2">
          <template slot="title">
            <span>软件著作权登记</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="2-1" @click.native="detail(5)">软件登记指南</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-submenu index="3">
          <template slot="title">
            <span>版权纠纷调解</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="3-1" @click.native="detail(6)">调解流程</el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <el-menu-item index="4" @click.native="detail(7)">
          <span slot="title">作品比对鉴定</span>
        </el-menu-item> 

        <el-submenu index="5">
          <template slot="title">
            <span>著作权登记资助</span> 
          </template>
          <el-menu-item-group>
            <el-menu-item index="5-1" @click.native="detail(8)">著作权登记资助指南</el-menu-item>
          </el-menu-item-group>
        </el-submenu>


      </el-menu>
    </div>

    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
 
  mounted() {},
  methods: {
    detail(id) {
      this.$router.replace({path: '/copyright/detail', query: {id: id}})
      
    }
  },
};
</script>
<style scoped>
.copyright {
  margin: 20px auto;
  margin-bottom: 100px;
  display: flex;
}
.directory {
  width: 15%;
  overflow: hidden;
}
.directory > p {
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
  margin-top: 20px;
}
.directory > p span {
  display: inline-block;
  padding: 7px 10px;
  font-weight: bold;
  border-bottom: 2px solid #016fb8;
}
.content {
  width: 80%;
  margin-top: 27px;
  margin-left: 30px;
}
</style>